import React from 'react';
import { fechaHora } from './date';

export const parseSerial = ({
  _id,
  request,
  response,
  createdAt,
  deviceName,
  changedAuxName,
  tipoAutomatizacion,
  auxPosition
}) => {
  let parsedRequest = {};
  let parsedResponse = {};

  try {
    parsedRequest = JSON.parse(request);
  } catch (e) {
    parsedRequest = {};
  }

  try {
    parsedResponse = JSON.parse(response);
  } catch (e) {
    parsedResponse = {};
  }

  return {
    key: typeof _id === 'object' && _id?.$oid ? _id.$oid : _id,
    serial: parsedRequest.serial || parsedResponse.serial || '-',
    deviceName: deviceName || '-',
    request: (
      <div>
        {Object.entries(parsedRequest)
          .filter(([k]) => k !== 'serial')
          .map(([k, v]) => {
            // Si la clave coincide con auxPosition y existe changedAuxName, mostrar el nombre del dispositivo
            if (k === auxPosition && changedAuxName) {
              return <div key={k}>{`${k}: ${v} - ${changedAuxName}`}</div>;
            }
            return <div key={k}>{`${k}: ${v}`}</div>;
          })}
        {tipoAutomatizacion && (
          <div>{`cambio: ${tipoAutomatizacion !== 'manual' ? 'automático' : tipoAutomatizacion}`}</div>
        )}
      </div>
    ),
    response: (
      <div>
        {parsedResponse.connected !== undefined && (
          <div>{`connected: ${parsedResponse.connected}`}</div>
        )}
      </div>
    ),
    createdAt: fechaHora(
      typeof createdAt === 'object' && createdAt?.$date
        ? createdAt.$date
        : createdAt
    ),
  };
};

export const parserSerialList = (list) =>
  list?.map((serial) => parseSerial(serial));